import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { Button } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import moment from "moment";

import Table from "../../../../Components/Table";
import Tag from "../../../../Components/Tag";

import { listarHistoricoImportacao, exportarHistoricoImportacao } from "../../../../Store/Actions/API/importacaoActions";
import { setParamsFilterImportacao } from "../../../../Store/Actions/Reducer/seguradoActions";
import { statusArquivo } from "../../../../Utils/constants";
import { useStyles } from "./styles";

const formatDate = "DD/MM/YYYY HH:mm:ss";

function HistoricoImportacao({ cpf }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { paramsFiltroImportacao } = useSelector((state) => state.segurado);
  const { importacao } = useSelector((state) => state.signalr);

  const [quantidadeBanco, setQuantidadeBanco] = useState(0);
  const [historico, setHistorico] = useState([]);

  useEffect(() => {
    lidarHistoricoImportacao();
  }, [paramsFiltroImportacao]); // eslint-disable-line

  useEffect(() => {
    atualizarStatusImportacao(importacao);
  }, [importacao]); // eslint-disable-line

  const lidarHistoricoImportacao = async () => {
    const filtros = { ...paramsFiltroImportacao, cpf };

    const response = await listarHistoricoImportacao(filtros);

    if (response !== null) {
      setQuantidadeBanco(response.quantidade ?? 0);
      setHistorico(response.arquivos ?? []);
    }
  };

  const atualizarStatusImportacao = async (record) => {
    if (!_.isEmpty(record)) {
      const index = _.findIndex(historico, { id: record.id });
      const novoRecord = {
        id: record.id,
        nome: record.nome,
        dataCarregamento: record.dataHora,
        status: record.status,
        notificacoes: record.notificacoes,
      };
      const novoHistorico = historico.slice(0);
      if (index === -1) {
        novoHistorico.unshift(novoRecord);
      } else {
        novoHistorico[index] = novoRecord;
      }
      setHistorico(
        novoHistorico.slice(0, paramsFiltroImportacao.itensPorPagina)
      );
    }
  };

  const lidarExportarHistorico = async () => {
    await exportarHistoricoImportacao(cpf);
  };

  const onChangePagination = (pag) => {
    dispatch(setParamsFilterImportacao(pag));
  };

  const renderStatus = (status, row) => {
    let statusTemp = statusArquivo[status];

    if (statusTemp) {
      return (
        <Tag
          text={statusTemp.titulo}
          color={statusTemp.tipo}
          tooltip={statusTemp.tooltip}
        />
      );
    } else {
      return <Tag text="-" color="success" tooltip="Sem status" />;
    }
  };

  const columns = [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      render: (value) => value,
    },
    {
      title: "Data de atualização",
      dataIndex: "dataCarregamento",
      key: "dataCarregamento",
      render: (value) => moment(value).format(formatDate),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value, row) => renderStatus(value, row),
    },
    {
      title: "",
      dataIndex: "notificacoes",
      key: "notificacoes",
      render: () => "",
    },
  ];

  const propsTable = {
    columns,
    data: historico,
    optionsPagination: {
      count: quantidadeBanco,
      pagination: { ...paramsFiltroImportacao },
      onChangePagination,
    },
    optionsToolbar: {
      title: "Histórico de importação",
      action: (
        <Button
          className={classes.button}
          startIcon={<CloudDownloadIcon />}
          onClick={lidarExportarHistorico}
        >
          Exportar
        </Button>
      ),
    },
    heightBody: "calc(100vh - 650px)"
  };

  if (historico?.length) {
    return <Table {...propsTable} />;
  } else {
    return null;
  }
}

export default HistoricoImportacao;
